import React, { useEffect, useRef, useState } from "react"

export default function OtpVerification({ appProps, otpPath, otpResendPath, onExpired }) {
  const [otpCode, setOtpCode] = useState(Array(6).fill(''))
  const [otpCountdown, setOtpCountdown] = useState(180)
  const otpInputRefs = useRef([])

  const { flashMessage } = appProps

  useEffect(() => {
    const interval = setInterval(() => {
      setOtpCountdown(prevCountdown => {
        if (prevCountdown <= 1) {
          clearInterval(interval)
          onExpired()

          return 180
        }

        return prevCountdown - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  function handleOtpSubmit() {
    let fd = new FormData()
    fd.append('otp_code', otpCode.join(''))

    Rails.ajax({
      type: 'POST',
      url: otpPath,
      dataType: 'json',
      data: fd,
      success: res => {
        if (res.redirect_url) {
          location.href = res.redirect_url
        }
      },
      error: res => {
        flashMessage.show(res.error, 'error')
      }
    })
  }

  function handleOtpChange(index, value) {
    const digit = value.replace(/\D/g, '').slice(-1)
    const nextOtpCode = [...otpCode]
    nextOtpCode[index] = digit
    setOtpCode(nextOtpCode)

    if (digit && index < otpCode.length - 1) {
      otpInputRefs.current[index + 1]?.focus()
    }
  }

  function handleOtpKeyDown(index, event) {
    if (event.key === 'Backspace' && !otpCode[index] && index > 0) {
      otpInputRefs.current[index - 1]?.focus()
    }
  }

  function handleOtpPaste(event) {
    event.preventDefault()

    const pastedCode = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, otpCode.length).split('')
    const nextOtpCode = [...otpCode]

    pastedCode.forEach((digit, index) => {
      nextOtpCode[index] = digit
    })

    setOtpCode(nextOtpCode)
    if (pastedCode.length) {
      otpInputRefs.current[Math.min(pastedCode.length, otpCode.length) - 1]?.focus()
    }
  }

  function handleOtpResend() {
    Rails.ajax({
      type: 'POST',
      url: otpResendPath,
      dataType: 'json',
      success: res => {
        setOtpCountdown(180)
        setOtpCode(Array(6).fill(''))
        flashMessage.show(res.message, 'success')
      },
      error: res => {
        flashMessage.show(res.error, 'error')
      }
    })
  }

  function formatOtpCountdown(seconds) {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60

    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
  }

  return (
    <div id='kt_sign_in_form' className="form w-100">
      <div className="text-center mb-11">
        <h1 className="text-dark fw-bolder mb-3">{ Website.translations.otpHeadingTitle }</h1>
        <div className="text-gray-500 fw-semibold fs-6">{ Website.translations.otpHeadingSubTitle }</div>
        <div className="text-gray-700 fw-semibold fs-5 mt-4">
          { Website.translations.otpCountdown } { formatOtpCountdown(otpCountdown) }
        </div>
      </div>
      <div className="flex-column mb-8 items-center content-center flex-box">
        <label htmlFor="otp_code">{ Website.translations.otpCode }</label>
        <div className="d-flex gap-2 mt-2">
          { otpCode.map((digit, index) => (
            <input
              key={ index }
              ref={ element => otpInputRefs.current[index] = element }
              type='text'
              inputMode='numeric'
              pattern='[0-9]*'
              maxLength='1'
              className='form-control bg-transparent text-center'
              value={ digit }
              onChange={ event => handleOtpChange(index, event.target.value) }
              onKeyDown={ event => handleOtpKeyDown(index, event) }
              onPaste={ handleOtpPaste }
              style={{ width: 50, height: 50, fontSize: 20 }}
            />
          )) }
        </div>
      </div>
      <div className="d-grid mb-5">
        <button type="submit" id="kt_otp_submit" className= "btn btn-primary" onClick={ ()=> handleOtpSubmit() }>
          { Website.translations.verifyOtpButton }
        </button>
      </div>
      <div className="text-gray-500 text-center fw-semibold fs-6">
        <button type="button" className="btn btn-link link-primary" onClick={ ()=> handleOtpResend() }>
          { Website.translations.resendOtpButton }
        </button>
      </div>
    </div>
  )
}
